module.exports = __webpack_public_path__ + "static/media/cmi-colour.5471a34c.png";